export const transition = { 
    duration: .5, 
    ease: [.56, .03, .12, 1.04]
};


export const variants = {
    hide: {
        opacity: 0.75,
        pointerEvents: 'none',
        x: '-101%'
    },
    show: {
        opacity: 1,
        pointerEvents: 'initial',
        x: '0'
    }
}